import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import FpxImage from '../../assets/fpx.png';
import ButtonWrapper from '../../components/ButtonWrapper';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: absolute;

`;

const TitleH2 = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 0px;
  text-align: left;
`;

const CardWrapper = styled.div`
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;

  @media (max-width: 600px) {
    width: 95%;
    padding: 10px;
  }
`;

const SuccessBox = styled.div`
  width: 550px;
  background: #fff;
  padding: 30px 0px;
  text-align: left;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  color: #28a745;
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin-top: 5px;
`;

const Detail = styled.div`
  margin-top: 20px;
  font-size: 0.9rem;
  line-height: 1.6;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap
`;

const Label = styled.span`
  font-weight: bold;
`;

const Value = styled.span`
  color: #333;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Footer = styled.footer`
  margin-top: 20px;
  font-size: 0.8rem;
  text-align: center;
  color: #aaa;
`;

const FpxPrint = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    const url = window.location.href;

    // "https://ppypayment-staging.xyzonline.app/myrfpx/fpx-transaction-status?dHJueERhdGVUaW1lPTIwMjUtMDEtMTkrMDglM0EzNCUzQTA3JnRybnhBbW91bnQ9MzAxLjAwJnNlbGxlck9yZGVyTm89UFBZLXZ3blJpZ24tT0NwT2JFb2t5ZWNnTmZQT0Y4bjdsMkVDbE1sVyZmcHhUcm54SWQ9MjUwMTE5MDAzNDA3MDI2OCZwcHlUcm54SWQ9UEFLVElaWEhERkNBVkVYSjEzOCZidXllckJhbmtOYW1lPVNCSStCYW5rK0EmdHJueFN0YXR1cz1TVUNDRVNTRlVMJnRybnhNZXNzYWdlPXVuZGVmaW5lZCUzQSt1bmRlZmluZWQ="
    // Extract the Base64 encoded string from the query parameter
    const queryString = url.split('?')[1];

    if (queryString) {
      const base64EncodedString = queryString.split('&')[0]; // Extract the first key-value pair
      const decodedString = atob(base64EncodedString); // Decode the Base64 string

      // Parse the decoded string into key-value pairs
      const params = decodedString.split('&').reduce((acc, param) => {
        const [key, value] = param.split('=');
        acc[key] = decodeURIComponent(value || '');
        return acc;
      }, {});

      const dateTimeString = params?.trnxDateTime;

      // Extract components
      const year = dateTimeString.slice(0, 4);     // 2025
      const month = dateTimeString.slice(4, 6); // 01 (JavaScript months are zero-indexed)
      const day = dateTimeString.slice(6, 8);      // 23
      const hour = dateTimeString.slice(8, 10);    // 01
      const minute = dateTimeString.slice(10, 12); // 47
      const second = dateTimeString.slice(12, 14); // 00

      // Create a Date object
      const formattedDate = `${day}-${month}-${year}, ${hour}:${minute}:${second}`

      setData({ ...params, trnxDateTime: formattedDate });
    } else {
      console.log('No query string found in the URL.');
    }
  }, []);


  return (
    <Container>
      <CardWrapper>
        <div className="d-flex align-items-center">
          <TitleH2>PAY WITH</TitleH2>
          <img src={FpxImage} alt="FPX" className="ms-3" />
        </div>

        <SuccessBox>
          {data?.trnxStatus === "SUCCESSFUL" ?
            <Header>
              <div>
                <Title>Payment Successful!</Title>
                <Subtitle>
                  Thank you! A receipt has been sent to your provided email address.
                </Subtitle>
              </div>
            </Header>
            :
            data?.trnxStatus === "PENDING+FOR+AUTHORIZER+TO+APPROVE" ?
              <Header>
                <div>
                  <Title style={{ color: 'orange', fontSize: 22 }}>PENDING AUTHORIZATION!</Title>
                  <Subtitle>
                    Transaction has been created
                  </Subtitle>
                </div>
              </Header>
              :
              <Header>
                <div>
                  <Title style={{ color: 'red' }}>Payment Unsuccessful!</Title>
                  <Subtitle>
                    Please contact support if payment was made
                  </Subtitle>
                </div>
              </Header>
          }

          <Detail>
            <DetailRow>
              <Label>Transaction Status:</Label>
              <Value style={{ color: data?.trnxStatus == "SUCCESSFUL" ? "green" : data?.trnxStatus === "PENDING+FOR+AUTHORIZER+TO+APPROVE" ? "black" : "red" }} >{(data?.trnxStatus)?.replace(/\+/g, ' ') || 'N/A'}</Value>
            </DetailRow>
            <DetailRow>
            {data?.trnxDateTime && data.trnxDateTime !== "--, ::" ? (
              <>
                <Label>Date:</Label>
                <Value>{data.trnxDateTime.replace(/\+/g, ' ') || "N/A"}</Value>
              </>
            ) : null}            
            {/* <Value>
              {
                data?.trnxDateTime && !data.trnxDateTime.includes("Invalid")
                  ? new Intl.DateTimeFormat('en-MY', {
                      timeZone: 'Asia/Kuala_Lumpur',
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                    }).format(new Date(data.trnxDateTime.replace(/\+/g, ' ')))
                  : 'N/A'
              }
              </Value> */}
            </DetailRow>
            <DetailRow>
              <Label>Bank:</Label>
              <Value>{(data?.buyerBankName || 'N/A').replace(/\+/g, ' ')}</Value>
            </DetailRow>
            <DetailRow>
              <Label>Amount:</Label>
              <Value>RM {data?.trnxAmount || 'N/A'}</Value>
            </DetailRow>
            <DetailRow>
              <Label>FPX Transaction ID:</Label>
              <Value>{data?.fpxTrnxId || 'N/A'}</Value>
            </DetailRow>
            <DetailRow>
              <Label>Transaction Message:</Label>
              <Value>{(data?.trnxMessage || 'N/A').replace(/\+/g, ' ')}</Value>
            </DetailRow>
            <DetailRow>
              <Label>Seller Order No:</Label>
              <Value style={{width: '50%', lineBreak:'anywhere', textAlign: 'right'}}>{data?.sellerOrderNo || 'N/A'}</Value>
            </DetailRow>
          </Detail>
        </SuccessBox>
        <ButtonGroup>
          <ButtonWrapper
            onClick={() => window.print()}
            border={true}
            bgColor="#003363"
            type="primary"
            color="#fff"
            size="middle"
            height="40px"
            text="Print"
          />
          <ButtonWrapper
            onClick={() => {
              let redirectionUrl  = localStorage.getItem("redirectionUrl");
                window.location.href = redirectionUrl;
              localStorage.removeItem("redirectionUrl");
            }}
            className="ms-4"
            border={true}
            bgColor="#438EF7"
            type="primary"
            color="#fff"
            size="middle"
            height="40px"
            text="Return to Merchant"
          />
        </ButtonGroup>
        <Footer>Papaya Pay Sdn Bhd © {new Date().getFullYear()} All Rights Reserved</Footer>
      </CardWrapper>
    </Container>
  );
};

export default FpxPrint;
